import { useEffect, useState } from "react";
import { supabase } from "../lib/supabase";
import { readSendFailed } from "../lib/vocabularyPublishChoice";

/** Outside `vocabulary.*`, so the editor's leaf reload cannot treat the blob as a field. */
const PUBLISHED_VOCABULARY_KEY = "published.vocabulary";

/** True only when the publication row says the last send did not land. */
export function usePublishedSendFailed(tenantId: string | null): boolean {
  const [sendFailed, setSendFailed] = useState(false);

  useEffect(() => {
    if (!tenantId) return;
    let active = true;

    const load = async () => {
      const { data, error } = await supabase
        .from("tenant_settings")
        .select("value")
        .eq("tenant_id", tenantId)
        .eq("key", PUBLISHED_VOCABULARY_KEY)
        .maybeSingle();
      if (!active) return;
      if (error) {
        console.warn(
          "[usePublishedSendFailed] failed to read published.vocabulary",
          error.message,
        );
        return;
      }
      setSendFailed(readSendFailed((data as { value?: unknown } | null)?.value));
    };

    void load();

    const channel = supabase
      .channel(`platform_published_vocabulary:${tenantId}`)
      .on(
        "postgres_changes",
        {
          event: "*",
          schema: "public",
          table: "tenant_settings",
          filter: `tenant_id=eq.${tenantId}`,
        },
        () => void load(),
      )
      .subscribe();

    return () => {
      active = false;
      supabase.removeChannel(channel);
    };
  }, [tenantId]);

  return sendFailed;
}
